<template>
    <div v-if="data.records !== undefined" class="m-3">
        <b-overlay :opacity="overlay.opacity" :show="overlay.visible" rounded="sm">
            <!-- title, breadcrumb -->
            <b-row>
                <!--  title  -->
                <b-col class="" cols="auto">
                    <h4>{{$tc(localeKey, 1)}}</h4>
                </b-col>
                <!-- breadcrumb, showing -->
                <b-col class="mr-auto ml-0 px-0" cols="auto">
                    <b-button-group size="sm">
                        <!-- breadcrumb -->
                        <b-button disabled variant="transparent"><b>
                            {{getBreadcrumb}}
                        </b>
                        </b-button>
                        <!-- showing -->
                        <b-button disabled variant="transparent"><b>
                            {{__getPaginationVisibleCount(data.records.length, $root.mx_pagination.perPage, currentPage)}}
                        </b>
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <!-- no hits -->
            <div v-if="data.records.length === 0">
                {{$t('form.no_hits')}}
            </div>
            <!-- products -->
            <b-card-group deck>
                <product
                    v-for="record in __getPaginationArrayItems(data.records, $root.mx_pagination.perPage, currentPage)"
                    :_record="record"
                    :data="data.data"
                    :uri="uri"
                ></product>
            </b-card-group>
            <!-- pagination -->
            <b-pagination
                v-model="currentPage"
                :per-page="$root.mx_pagination.perPage"
                :total-rows="data.records.length"
                limit="20"
                size="sm"
            ></b-pagination>
        </b-overlay>
    </div>
</template>

<script>
import Product from "@/components/_public/_product/Product";

export default {
    name: "Products",
    components: {Product},
    props: {},
    data() {
        return {
            localeKey: 'public.product.main',
            overlay: {
                visible: false,
                opacity: 0.7,
            },
            uri: {
                uri1: `api/v1/_public/products`,
                uri2: `api/v1/_public/product`,
                organisation: `api/v1/_public/suppliers`,
                carts: `api/v1/cart/carts`,
            },
            data: [],
            currentPage: 1,
        }
    },
    mounted() {
        this.$root.mx_pagination.visible = true;
        this.baseSelect();
    },
    destroyed() {
        this.$root.mx_pagination.visible = false;
    },
    methods: {
        showOverlay(show) {
            this.overlay.visible = show;
        },
        // <-- api calls -->
        baseSelect: function () {
            this.showOverlay(true);
            this.axios.get(this.uri.uri1 + `/${this.$route.params.type_id}`)
                .then((response) => {
                    this.$set(this, 'data', response.data);
                    this.showOverlay(false);
                })
                .catch((error) => {
                    // console.log("ERROR:", error.response.data);
                });
        },
    },
    computed: {
        getBreadcrumb() {
            if (this.__isNull(this.data) || !this.data.records.length > 0) {
                return null;
            }
            // <-- all products -->
            if (this.$route.params.type_id === 'null') {
                return '(' + this.$t('public.product.all') + ')';
            }
            // <--  -->
            let record_type = this.data.records[0].product_type;
            // <-- group -->
            let record_group = record_type.product_group;
            let group = record_group.meta.name;
            let localeTemp = this.__getJsonLocaleValue(record_group.locale, 'name');
            group = localeTemp === null ? group : localeTemp;
            // <-- type -->
            let type = record_type.meta.name;
            localeTemp = this.__getJsonLocaleValue(record_type.locale, 'name');
            type = localeTemp === null ? type : localeTemp;
            // <--  -->
            return '(' + group + ' / ' + type + ')';
        },
    },
    filters: {},
    watch: {
        '$route.params.type_id': {
            handler: function (value, oldValue) {
                this.baseSelect();
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
